import type { ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

interface ProtectedRouteProps {
    isAllowed: boolean
    redirectPath?: string
    children?: ReactNode
}

export const ProtectedRoute = ({
    isAllowed,
    redirectPath = '/',
    children,
}: ProtectedRouteProps) => {
    const location = useLocation()

    if (!isAllowed) {
        // Combine pathname and search to preserve the full URL, including query parameters
        const fullPath = `${location.pathname}${location.search}`

        return <Navigate to={redirectPath} state={{ from: fullPath }} replace />
    }

    return children ?? <Outlet />
}
